import { render, staticRenderFns } from "./weiXiuError.vue?vue&type=template&id=d843b2a8&"
import script from "./weiXiuError.vue?vue&type=script&lang=js&"
export * from "./weiXiuError.vue?vue&type=script&lang=js&"
import style0 from "./weiXiuError.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports